import * as v from "valibot";

import { rpcContract } from "../rpc";

export const trackAnalyticsRpcContract = rpcContract({
  name: "trackAnalytics",
  paramsSchema: v.object({
    // Profile handle being viewed (to determine influencer_id)
    handle: v.string(),

    // Optional context fields for existing analytics system integration
    statisticType: v.optional(
      v.picklist([
        "PAGEVIEW",
        "EVENT",
        "CLICK_POST_DISCOUNT",
        "CLICK_POST_URL",
        "CLICK_POST_DISCOUNT_EXPLORE",
        "CLICK_POST_URL_EXPLORE",
        "CLICK_POST_DISCOUNT_FEED",
        "CLICK_POST_URL_FEED",
        "PWA_BANNER_SHOWN",
        "PWA_BANNER_CLICKED",
        "PWA_BANNER_DISMISSED",
        "PWA_INSTALL_ACCEPTED",
        // Live Event tracking
        "LIVE_EVENT_PAGE_VIEWED",
        "LIVE_EVENT_CREATOR_CLICKED",
        "LIVE_EVENT_WHATSAPP_CLICKED",
        "LIVE_EVENT_SHARED",
        "LIVE_EVENT_BUY_TICKET_CLICKED",
        "LIVE_EVENT_LINK_OPENED",
        "LIVE_EVENT_CODE_COPIED",
        "LIVE_EVENT_JOIN_STREAM_CLICKED",
        "POST_LIVESTREAM_PRODUCT_CTA_CLICKED",
        "POST_LIVESTREAM_COMMUNITY_CTA_CLICKED",
        "POST_LIVESTREAM_RETURN_CLICKED",
        "POST_LIVESTREAM_MODAL_CLOSED",
        // Community Onboarding Questionnaire
        "QUESTIONNAIRE_SHOWN",
        "QUESTIONNAIRE_QUESTION_ANSWERED",
        "QUESTIONNAIRE_ABANDONED",
      ]),
    ),
    anonymousId: v.optional(v.string()),
    postId: v.optional(v.string()),
    bioLinkId: v.optional(v.string()),
    discountId: v.optional(v.string()),
    socialLink: v.optional(v.string()),
    metadata: v.optional(v.record(v.string(), v.string())),
  }),
  resultSchema: v.undefined(),
});

export type TrackAnalyticsParams = v.InferOutput<(typeof trackAnalyticsRpcContract)["paramsSchema"]>;
export type TrackAnalyticsResult = v.InferOutput<(typeof trackAnalyticsRpcContract)["resultSchema"]>;
